import { render, staticRenderFns } from "./FinanceSalarySliceTable.vue?vue&type=template&id=386450c0&"
import script from "./FinanceSalarySliceTable.vue?vue&type=script&lang=js&"
export * from "./FinanceSalarySliceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports